import { render, staticRenderFns } from "./mainProfile.vue?vue&type=template&id=37eee8e0&scoped=true&"
import script from "./mainProfile.vue?vue&type=script&lang=js&"
export * from "./mainProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37eee8e0",
  null
  
)

export default component.exports